/**
 * <dogbook-hero> — full-bleed crossfade slideshow.
 * Progressive enhancement: markup renders the first slide visible without JS.
 * Lifecycle-safe (connected/disconnected), theme-editor aware, reduced-motion aware.
 */
if (!customElements.get('dogbook-hero')) {
  class DogbookHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-db-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-db-dot]'));
      this.index = 0;
      this.timer = null;

      if (this.slides.length <= 1) return;

      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 6000);
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onDotClick = this.onDotClick.bind(this);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

      if (this.autoplay && !this.reduce) this.start();

      // Pause on hover / focus / off-screen
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.autoplay && !this.reduce && this.start());
      this.addEventListener('focusin', () => this.stop());
    }

    disconnectedCallback() {
      this.stop();
    }

    go(i) {
      if (i === this.index) return;
      this.slides[this.index].classList.remove('is-active');
      this.dots[this.index]?.setAttribute('aria-current', 'false');
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
      this.dots[this.index]?.setAttribute('aria-current', 'true');
    }

    onDotClick(i) {
      this.go(i);
      this.stop();
      if (this.autoplay && !this.reduce) this.start();
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  customElements.define('dogbook-hero', DogbookHero);
}
